import React from 'react'

interface Props {
  name: string
  email: string
}

const Invitee: React.FC<Props> = ({ name, email }) => {
  return (
    <div className="max-w-full text-left flex flex-wrap @md:flex-row">
      <span className="font-bold mr-1">{name}</span>{' '}
      <span className="truncate max-w-full">{`<${email}>`}</span>
    </div>
  )
}

export default Invitee
